// Third Party Library
import { List, Drawer} from "antd";

// Components Library
import { ButtonLink } from "../../../../../../components";

// Styles Library
import "./index.css";


const PayrollAdvanceCompany = (props) => {
  const { isOpen, setIsOpen, companies, dataSource, filteredData, setFilteredData, setTabKey, setIsPending } = props;

  const companyList = (
    <List
      itemLayout="horizontal"
      dataSource={companies}
      renderItem={(cel, i) => {
        const { company_name, status, coid } = cel;

        const handleFilterPending = (id) => {
          setTabKey(1)
          const newData = filteredData.filter((d) => d.status === 1 && d.coid === id)
          setFilteredData(newData)
          setIsOpen(false)
          setIsPending(true)
        }

        const Title = () => {
          return (
            <>
              <ButtonLink onClick={() => handleFilterPending(coid)}>{company_name}</ButtonLink>
            </>
          );
        };

        const Description = () => {
          const total = dataSource.filter((d) => d.status === status && d.coid === coid);

          return (
            <>
              <span> Current pending for processing: {total?.length}</span>
            </>
          );
        };

        return (
              <List.Item className="list-container">
                <List.Item.Meta
                  title={<Title />}
                  description={<Description />}
                />
              </List.Item>
        );
      }}
    />
  );

  return (
    <>
      <Drawer
        title={"Payroll Advance By Company"}
        open={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
        width={410}
        style={{
          fontSize: "15px",
          textAlign: "left"
        }}
      >
        <span>Total Companies: - {companies?.length || 0}</span>
        <div style={{marginTop: "20px"}}></div>
        {companyList}
      </Drawer>
    </>
  );
};

export default PayrollAdvanceCompany;